export default __webpack_public_path__ + "static/media/tick.d5ae64d8.svg";